<div class="config-loading" *ngIf="!loaded">
    <div class="k-i-loading"></div>
</div>

<app-ranges-markets *ngIf="loaded && !loadError && mode === 'ranges'" [initial]="response"></app-ranges-markets>
<app-service-markets *ngIf="loaded && !loadError && mode === 'services'" [initial]="response"></app-service-markets>
